export default __webpack_public_path__ + "static/media/sketch-youth-tn.cf3512a2.png";